import { Table, TableName } from '@openx/components-table/Table';
import type { ProvidersList as ProvidersListType } from '@openx/types/provider';
import type { AllTableCriteria, CriteriaChange, CriteriaDimension } from '@openx/types/tableCriteria';
import { useProviderContext } from '../../utils/context/ProviderContext';
import type { ProvidersListFilters } from '../types';
import { ProvidersTopBar } from './ProvidersTopBar';

export type ProvidersListProps = {
  criteria: AllTableCriteria<ProvidersListFilters>;
  handleCriteriaChange: (newCriteria: CriteriaChange<CriteriaDimension, ProvidersListFilters>) => void;
  loading: boolean;
  providers: ProvidersListType[];
};

export const ProvidersList = ({ criteria, handleCriteriaChange, loading, providers }: ProvidersListProps) => {
  const { useGetProvidersTableData } = useProviderContext();
  const { rowActions, tableColumns } = useGetProvidersTableData(criteria.filters?.phrase);

  return (
    <>
      <ProvidersTopBar criteria={criteria} onChange={handleCriteriaChange} />
      <Table
        name={TableName.PROVIDERS}
        columns={tableColumns}
        criteria={criteria}
        data={providers}
        loading={loading}
        onCriteriaChange={handleCriteriaChange}
        rowActions={rowActions}
      />
    </>
  );
};
